import React, { useEffect, useState } from 'react';
import {
  Table,
  Button,
  Input,
  Select,
  Popconfirm,
  Space,
  Card,
  Flex,
} from 'antd';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import { queryKeys } from '../../../services/react-query/queryKeys';
import { useMutation, useQuery } from '@tanstack/react-query';
import { getSearchApi } from '../../../network/itemList';
import { getSearchApiIsStock } from '../../../network/appointment';
import { getItemDetails } from '../../../network/materialRequest';
import { ModalAppItemDetails } from '../ModalApp/ModalApp';
import dayjs from 'dayjs';
import { BiSolidShow } from 'react-icons/bi';
const ItemListStockEntry = ({
  warehouse,
  setDataSource,
  dataSource,
  watchStockEntryType,
  form,
  t,
}) => {
  const [count, setCount] = useState(0);
  const [searchTextItems, setSearchTextItems] = useState('');
  const [selectData, setSelectData] = useState({});
  const [open, setOpen] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const { data: itemsList } = useQuery({
    queryKey: [queryKeys.getSearchApiIsStock, searchTextItems],
    queryFn: () =>
      getSearchApiIsStock({ type: 'Item', text: searchTextItems, stock: 1 }),
    keepPreviousData: true,
    enabled: searchTextItems?.length >= 3 || searchTextItems?.length === 0,
  });
  const { mutate: onGetItemDetails } = useMutation({
    mutationFn: (itemName) => getItemDetails('Material Request', itemName),
    onSuccess: (itemDetails) => {
      console.log(itemDetails, 'itemDetails');
      const newDataSource = [...dataSource];
      newDataSource[selectedIndex] = {
        ...newDataSource[selectedIndex],
        ...itemDetails?.message,
        warehouse: form.getFieldValue('set_warehouse'),
        // item_code: itemDetails?.message?.item_name,
      };
      setDataSource(newDataSource);
    },
    onError: (error) => {
      console.log(error, 'error');
    },
  });
  const { data: payrollcostcenter } = useQuery({
    queryKey: [queryKeys.getCostCenterSearch],
    queryFn: () => getSearchApi('Cost Center'),
    keepPreviousData: true,
  });
  const columns = [
    {
      title: t.items,
      dataIndex: 'item_code',
      render: (text, record, index) => (
        <Select
          placeholder={t.items}
          value={
            record?.item_code
              ? {
                  key: record.item_code,
                  label: itemsList?.message?.find(
                    (i) => i.value === record.item_code
                  )?.description,
                }
              : undefined
          }
          labelInValue
          style={{ width: '200px' }}
          showSearch
          filterOption={false}
          onSearch={(value) => setSearchTextItems(value)}
          onChange={(value, option) => {
            setSelectedIndex(index);
            onGetItemDetails(value.key);
            const newDataSource = [...dataSource];
            newDataSource[index] = {
              ...newDataSource[index],
              item_code: value.key,
              rate: option?.option?.rate,
              qty: 1,
              amount: option?.option?.rate * 1,
            };
            setDataSource(newDataSource);
          }}
          popupMatchSelectWidth={false}
        >
          {itemsList?.message?.map((item) => (
            <Select.Option
              key={item?.value}
              value={item?.value}
              label={item?.description}
            >
              <Flex gap={1} vertical>
                <span>{item?.value}</span>
                <span
                  className="item-description"
                  style={{ fontSize: '11px', color: 'gray' }}
                >
                  {item?.description}
                </span>
              </Flex>
            </Select.Option>
          ))}
        </Select>
      ),
    },
    {
      title: t.SourceWarehouse,
      hidden: watchStockEntryType === 'Material Receipt' ? true : false,
      dataIndex: 's_warehouse',
      render: (text, record, index) => (
        <Select
          placeholder={t.SourceWarehouse}
          style={{ width: '100%' }}
          popupMatchSelectWidth={false}
          value={record?.s_warehouse}
          onChange={(value) => {
            const newDataSource = [...dataSource];
            newDataSource[index] = {
              ...newDataSource[index],
              s_warehouse: value,
            };
            setDataSource(newDataSource);
          }}
          options={warehouse?.data?.map((item) => ({
            value: item?.name,
            label: item?.warehouse_name,
          }))}
        />
      ),
    },
    {
      hidden: watchStockEntryType === 'Material Issue' ? true : false,
      title: t.TargetWarehouse,
      dataIndex: 't_warehouse',
      // hidden:
      //   watchStockEntryType !== 'Material Transfer'
      //     ? false
      //     : watchStockEntryType === 'Material Receipt'
      //     ? false
      //     : watchStockEntryType === 'Material Issue'
      //     ? true
      //     : false,
      render: (text, record, index) => (
        <Select
          placeholder={t.TargetWarehouse}
          style={{ width: '100%' }}
          popupMatchSelectWidth={false}
          value={record?.t_warehouse}
          onChange={(value) => {
            const newDataSource = [...dataSource];
            newDataSource[index] = {
              ...newDataSource[index],
              t_warehouse: value,
            };
            setDataSource(newDataSource);
          }}
          options={warehouse?.data?.map((item) => ({
            value: item?.name,
            label: item?.warehouse_name,
          }))}
        />
      ),
    },
    {
      title: t.costCenter,
      dataIndex: 'cost_center',
      render: (text, record, index) => (
        <Select
          placeholder={t.TargetWarehouse}
          style={{ width: '100%' }}
          popupMatchSelectWidth={false}
          value={record?.cost_center}
          onChange={(value) => {
            const newDataSource = [...dataSource];
            newDataSource[index] = {
              ...newDataSource[index],
              cost_center: value,
            };
            setDataSource(newDataSource);
          }}
          options={payrollcostcenter?.message?.map((user) => ({
            value: user.value,
            label: user.value,
          }))}
        />
      ),
    },
    {
      title: t.Rate,
      dataIndex: 'rate',
      render: (text, record, index) => (
        <Input
          placeholder={t.Rate}
          type="number"
          // value={record.amount}
          value={record.rate}
          onChange={(e) => {
            const newDataSource = [...dataSource];
            newDataSource[index] = {
              ...newDataSource[index],
              rate: e.target.value,
              amount: e.target.value * +record?.qty,
            };
            setDataSource(newDataSource);
          }}
          min={0}
          disabled
          // style={{ width: 140 }}
          style={{ width: '100%' }}
        />
      ),
    },
    {
      title: t.quantity,
      dataIndex: 'qty',
      render: (text, record, index) => (
        <Input
          placeholder={t.quantity}
          type="number"
          // value={record.amount}
          value={record.qty}
          onChange={(e) => {
            const newDataSource = [...dataSource];
            newDataSource[index] = {
              ...newDataSource[index],
              qty: e.target.value,
              amount: e.target.value * +record?.rate,
            };
            setDataSource(newDataSource);
          }}
          min={0}
          // style={{ width: 140 }}
          style={{ width: '100%' }}
        />
      ),
    },
    {
      title: t.amount,
      dataIndex: 'amount',
      render: (text, record, index) => (
        <Input
          placeholder={t.amount}
          type="number"
          // value={record.amount}
          value={record.amount}
          disabled
          min={0}
          style={{ width: '100%' }}
        />
      ),
    },
    {
      title: t.action,
      key: 'action',
      render: (text, record, index) => (
        <Space>
          <Button
            type="primary"
            // icon={<MdEdit />}
            icon={<BiSolidShow />}
            size="small"
            onClick={() => {
              setSelectedIndex(index);
              handleDetails(record.key);
            }}
          />
          <Popconfirm
            title={t.confirmDelete}
            onConfirm={() => handleDelete(record.key)}
          >
            <Button
              type="primary"
              danger
              icon={<DeleteOutlined />}
              size="small"
            />
          </Popconfirm>
        </Space>
      ),
    },
  ];

  const handleAdd = () => {
    const newData = {
      key: count,
      s_warehouse: form.getFieldValue('from_warehouse'),
      t_warehouse: form.getFieldValue('to_warehouse'),
    };
    setDataSource([...dataSource, newData]);
    setCount(count + 1);
  };

  const handleDelete = (key) => {
    const newDataSource = dataSource.filter((item) => item.key !== key);
    setDataSource(newDataSource);
  };
  const handleDetails = (key) => {
    const row = dataSource.find((item) => item.key === key);
    if (row) {
      setSelectData({
        ...row,
        schedule_date: dayjs(row.schedule_date).format('YYYY-MM-DD'),
      });
      setDataSource(
        dataSource.map((item) => ({
          ...item,
          schedule_date: dayjs(item.schedule_date).format('YYYY-MM-DD'),
        }))
      );
      setOpen(true);
      console.log('Row details:', row);
    }
  };
  return (
    <Card>
      <Table
        className="table_custom"
        dataSource={dataSource}
        columns={columns}
        pagination={{
          hideOnSinglePage: true,
        }}
        scroll={{ x: 'max-content' }}
        // className="table"
        rowKey="key"
      />
      <Button
        onClick={handleAdd}
        type="primary"
        ghost
        style={{ marginTop: '20px', borderRadius: '6px' }}
        icon={<PlusOutlined />}
        size="small"
      >
        {t.addRow}
      </Button>
      <ModalAppItemDetails
        setDataSource={setDataSource}
        dataSource={dataSource}
        selectedIndex={selectedIndex}
        open={open}
        setOpen={setOpen}
        type="Purchase Order"
        t={t}
        selectData={selectData}
      />
    </Card>
  );
};

export default ItemListStockEntry;
